import { useState } from 'react';
import { Link } from 'react-router-dom';
import { UBER_URL, DELIVEROO_URL } from '../constants';

function Arrow() {
  return (
    <span style={{ fontSize: '20px', color: '#000000', lineHeight: 1, display: 'flex', alignItems: 'center' }}>→</span>
  );
}

function CardLabel({ children }) {
  return (
    <div style={{ height: '48px', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f5f5f5', flexShrink: 0 }}>
      <p style={{ fontFamily: 'Rough Motion, sans-serif', fontSize: '18px', fontWeight: '400', color: '#000000', margin: 0, textTransform: 'uppercase', letterSpacing: '1px' }}>
        {children}
      </p>
      <Arrow />
    </div>
  );
}

function LivraisonModal({ onClose }) {
  return (
    <div
      style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
      onClick={onClose}
    >
      <div
        style={{ backgroundColor: '#fff', borderRadius: '16px', width: '100%', maxWidth: '400px', padding: '40px 32px 32px', boxSizing: 'border-box', position: 'relative' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Croix */}
        <button
          onClick={onClose}
          style={{ position: 'absolute', top: '14px', right: '14px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#aaa', lineHeight: 1, padding: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          aria-label="Fermer"
        >
          ✕
        </button>

        <h2 style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '22px', fontWeight: '400', color: '#000', margin: '0 0 28px 0', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'center' }}>
          Choisissez votre plateforme
        </h2>
        <div style={{ display: 'flex', gap: '12px' }}>
          <a
            href={UBER_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '20px 16px', borderRadius: '12px', border: '1.5px solid #e0e0e0', textDecoration: 'none', backgroundColor: '#fff', cursor: 'pointer', transition: 'border-color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#000'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#e0e0e0'}
          >
            <img src="/uber.png" alt="Uber Eats" style={{ width: '100%', maxHeight: '36px', objectFit: 'contain' }} />
            <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', fontWeight: '600', color: '#000', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Commander →
            </span>
          </a>
          <a
            href={DELIVEROO_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '20px 16px', borderRadius: '12px', border: '1.5px solid #e0e0e0', textDecoration: 'none', backgroundColor: '#fff', cursor: 'pointer', transition: 'border-color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#00CCBC'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#e0e0e0'}
          >
            <img src="/deliveroo.png" alt="Deliveroo" style={{ width: '100%', maxHeight: '36px', objectFit: 'contain' }} />
            <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', fontWeight: '600', color: '#000', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Commander →
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

/* Card 1 */
function Card1() {
  return (
    <Link to="/localisation" className="grid-card grid-card-1" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '28px', padding: '40px', boxSizing: 'border-box', backgroundColor: '#fff' }}>
      <p style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '36px', fontWeight: '400', color: '#000000', textAlign: 'center', margin: 0, lineHeight: '1.1', textTransform: 'uppercase', letterSpacing: '1px' }}>
        Trouvez nous
      </p>
      <span style={{ backgroundColor: '#fff', color: '#C10230', fontFamily: 'Jane Light, sans-serif', fontSize: '15px', fontWeight: '600', padding: '12px 24px', borderRadius: '8px', border: '2px solid #C10230', display: 'inline-block', boxSizing: 'border-box', textTransform: 'uppercase' }}>
        Voir notre emplacement
      </span>
    </Link>
  );
}

/* Card 2 */
function Card2() {
  return (
    <Link to="/la-carte" className="grid-card grid-card-2" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, backgroundColor: '#C10230', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 0 }}>
        <img src="/logo.svg" alt="La Carte" style={{ width: '60%', height: '60%', objectFit: 'contain' }} />
      </div>
      <CardLabel>La Carte</CardLabel>
    </Link>
  );
}

/* Card 3 */
function Card3({ onOpen }) {
  return (
    <div onClick={onOpen} className="grid-card grid-card-3" style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer' }}>
      <div style={{ flex: 1, backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '20px', padding: '40px', boxSizing: 'border-box', minHeight: 0 }}>
        <img src="/uber.png" alt="Uber Eats" style={{ width: '100%', objectFit: 'contain', maxHeight: '100px' }} />
        <img src="/deliveroo.png" alt="Deliveroo" style={{ width: '100%', objectFit: 'contain', maxHeight: '60px' }} />
      </div>
      <CardLabel>Livraison</CardLabel>
    </div>
  );
}

/* Card 4 */
function Card4() {
  return (
    <div className="grid-card grid-card-4" style={{ backgroundColor: '#C10230', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img src="/gratinervos.png" alt="Gratiner" style={{ width: '65%', height: '65%', objectFit: 'contain' }} />
    </div>
  );
}

/* Card 5 */
function Card5() {
  return (
    <div className="grid-card grid-card-5" style={{ backgroundColor: '#000000' }}>
      <img src="/devanture.jpg" alt="Devanture" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
    </div>
  );
}

/* Card 6 */
function Card6() {
  return (
    <div className="grid-card grid-card-6" style={{ backgroundColor: '#000000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img src="/etudiant.png" alt="Etudiant" style={{ width: '100%', height: '100%', objectFit: 'fill' }} />
    </div>
  );
}

export default function Grid() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="home-grid">
        <Card1 />
        <Card2 />
        <Card3 onOpen={() => setModalOpen(true)} />
        <Card4 />
        <Card5 />
        <Card6 />
      </div>

      {modalOpen && <LivraisonModal onClose={() => setModalOpen(false)} />}
    </>
  );
}
